import { graphql } from 'gatsby';
import React from 'react';
import StickyBox from 'react-sticky-box';

import RichTextConverter from '../components/Common/RichText/RichTextConverter';
import SmartLink from '../components/Common/SmartLink';
import Layout from '../components/Layouts/Layout';
import MarketingSeo from '../components/MarketingSeo';
import PageSection from '../components/PageSections/PageSection';
import { addTrailingSlash } from '../tools/textTools';
import * as styles from './legal.module.scss';

const SimplePage = ({ data: { page }, pageContext, location }) => {
  const useH2 = page.pageTitle?.length > 70;
  let main = (
    <>
      <h1 className={useH2 ? styles.secondaryH1 : styles.mainH1}>{page.pageTitle}</h1>
      <RichTextConverter copy={page.body} />
    </>
  );
  if (pageContext.pages) {
    main = (
      <div className={styles.layout}>
        <div className={styles.sticky} data-analytics-section={'sticky-nav'}>
          <StickyBox offsetTop={84} offsetBottom={10}>
            <nav className={styles.menu}>
              <ul className={'unstyled-list'}>
                {pageContext.pages
                  .filter((p) => p.groupHome)
                  .map((item) => {
                    const slug = addTrailingSlash(item.slug);
                    return (
                      <li data-analytics-component={'nav-link'} data-analytics-id={item.slug} key={'home'}>
                        <SmartLink to={`/${slug}`}>{item.pageTitle}</SmartLink>
                      </li>
                    );
                  })}
                {pageContext.pages
                  .filter((p) => !p.groupHome)
                  .map((item, i) => {
                    const slug = addTrailingSlash(item.slug);
                    return (
                      <li data-analytics-component={'nav-link'} data-analytics-id={item.slug} key={i}>
                        <SmartLink to={`/${slug}`}>{item.pageTitle}</SmartLink>
                      </li>
                    );
                  })}
              </ul>
            </nav>
          </StickyBox>
        </div>
        <section data-analytics-section={'simple-page-body'}>
          <RichTextConverter copy={page.body} />
        </section>
      </div>
    );
  }

  return (
    <Layout pageMeta={page.pageMetaData} isDach={pageContext.isDach}>
      <PageSection isTopSection>{main}</PageSection>
    </Layout>
  );
};

export default SimplePage;

export const Head = ({ data: { page }, location }) => (
  <MarketingSeo meta={page.pageMetaData} slug={location.pathname} />
);

export const query = graphql`
  query SimplePageQuery($slug: String!) {
    page: contentfulPageSimple(slug: { eq: $slug }) {
      pageTitle
      body {
        raw
        references {
          ... on Node {
            ...JumpLink
          }
        }
      }
      pageMetaData {
        ... on Node {
          ...PageMetaData
        }
      }
    }
  }
`;
